import { render, staticRenderFns } from "./user_profile_stats.vue?vue&type=template&id=17f900ee"
import script from "./user_profile_stats.vue?vue&type=script&lang=js"
export * from "./user_profile_stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports